import { Flex } from '@shared/components';

import { BaseAlert } from '../../components';

export default function InReviewQSetListBanner() {
  return (
    <Flex sx={{ padding: (theme) => theme.spacing(4), width: '100%' }}>
      <BaseAlert severity='info'>ชุดข้อสอบอยู่ระหว่างการตรวจสอบ</BaseAlert>
    </Flex>
  );
}
